export enum BlockListType{
    ContentBlockList = 1, // Use to define Umbraco content block list
    AngularBlockList = 2 ,//Use to define Angular block list
    PersonalBlockList=3
}